import { SortingEnum } from './enums/SortingEnum';
export const sortItems = (a, b, sortBy) => {
    if (!a.totalPrice || !b.totalPrice) {
        return 0;
    }
    const priceA = a.totalPrice.family ? a.totalPrice.familyInclTax : a.totalPrice.inclTax;
    const priceB = b.totalPrice.family ? b.totalPrice.familyInclTax : b.totalPrice.inclTax;
    switch (sortBy) {
        case SortingEnum.BestFit:
            return b.cluster_size - a.cluster_size;
        case SortingEnum.PriceDesc:
            return priceB - priceA;
        case SortingEnum.PriceAsc:
            return priceA - priceB;
        default:
            return 0;
    }
};
//# sourceMappingURL=sorting.js.map